import mixpanel from 'mixpanel-browser';
import posthog from 'posthog-js';

import { MIXPANEL_TOKEN, POSTHOG_HOST, POSTHOG_KEY } from '@/configuration/client';
import isInPopoverWidget from '@/helpers/isInPopoverWidget';

let appName = 'web';

export function mixpanelTrack(eventName: string, eventInfo?: Record<string, unknown>): void {
  const isWidgetEvent = isInPopoverWidget();
  const properties = { ...eventInfo, appType: appName, isWidgetEvent };

  if (navigator?.cookieEnabled && MIXPANEL_TOKEN) {
    mixpanel.track(eventName, properties);
  }

  // TODO(will): Re-enable PostHog capture when we want to compare PostHog with Mixpanel
  // if (navigator?.cookieEnabled && POSTHOG_KEY && POSTHOG_HOST) {
  //   posthog.capture(eventName, properties);
  // }
}

export function mixpanelAlias(aliasId: string): void {
  if (navigator?.cookieEnabled && MIXPANEL_TOKEN) {
    const currentDistinctId = mixpanel.get_distinct_id() as string;
    if (aliasId !== currentDistinctId) {
      mixpanel.alias(aliasId, currentDistinctId);
    }
  }

  if (navigator?.cookieEnabled && POSTHOG_KEY && POSTHOG_HOST) {
    const currentDistinctId = posthog.get_distinct_id();
    if (aliasId !== currentDistinctId) {
      posthog.alias(aliasId, currentDistinctId);
    }
  }
}

export function mixpanelSet(userInfo: Record<string, unknown>): void {
  if (navigator?.cookieEnabled && MIXPANEL_TOKEN) {
    mixpanel.people.set(userInfo);
  }

  if (navigator?.cookieEnabled && POSTHOG_KEY && POSTHOG_HOST) {
    posthog.setPersonProperties(userInfo);
  }
}

export function mixpanelReset(): void {
  if (navigator?.cookieEnabled && MIXPANEL_TOKEN) {
    mixpanel.reset();
  }

  if (navigator?.cookieEnabled && POSTHOG_KEY && POSTHOG_HOST) {
    posthog.reset();
  }
}

export function getMixpanelId(): string | null {
  if (navigator?.cookieEnabled && MIXPANEL_TOKEN) {
    return mixpanel.get_distinct_id() as string;
  }
  return null;
}

/**
 * Get distinct IDs from both Mixpanel and PostHog.
 */
export function getAnalyticsIds(): { mixpanel: string | null; posthog: string | null } {
  const mixpanelId = navigator?.cookieEnabled && MIXPANEL_TOKEN ? (mixpanel.get_distinct_id() as string) : null;
  const posthogId =
    navigator?.cookieEnabled && POSTHOG_KEY && POSTHOG_HOST ? (posthog.get_distinct_id() as string) : null;

  return { mixpanel: mixpanelId, posthog: posthogId };
}

// Should only be used in MixpanelIdentify
export function setMixpanelAppName(thisAppType: string): void {
  appName = thisAppType;
}
